import { ReactNode, useEffect, useState } from 'react';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

interface ItemCardRootProps {
  children: ReactNode;
}

export const ItemCardRoot = ({ children }: ItemCardRootProps) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setMounted(true);
    }, 20);
    return () => clearTimeout(timer);
  }, []);

  return <ItemCardContainer className={mounted ? 'mounted' : ''}>{children}</ItemCardContainer>;
};

// 저사양 디바이스에서 애니메이션 처리를 위해 클래스 토글 방식으로 사용
const ItemCardContainer = styled.div`
  position: relative;
  margin: 0 0 8px;
  padding: 17px 16px 16px 16px;
  border-radius: 8px;
  background: ${vars.v3Color.gray50};

  opacity: 0;
  transform: translate3d(0, 110px, 0);
  transition:
    opacity 0.1s ease-in-out,
    transform 0.2s ease-in-out;
  will-change: transform, opacity;

  &.mounted {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  &:last-child {
    margin: 0;
  }
`;
